import { CarouselLoad } from "./carousel-load";
import { CarouselLoadIE } from "./carousel-load-ie";

const config = {
  init: false,
  loop: false,
  simulateTouch: false,
  navigation: {
    prevEl: ".js-carousel-topics-prev",
    nextEl: ".js-carousel-topics-next",
  },
  slidesPerView: "auto",
  slidesPerGroup: 5,
  spaceBetween: 0,
  watchSlidesProgress: true,
  watchSlidesVisibility: true,
  breakpointsInverse: true,
  breakpoints: {
    1040: {
      slidesPerView: 6,
      slidesPerGroup: 6,
    },
    1200: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
  },
};

window.addEventListener("load", () => {
  if ("IntersectionObserver" in window) {
    new CarouselLoad(".js-carousel-topics", config, false, true);
  } else {
    new CarouselLoadIE(".js-carousel-topics", config);
  }
});
